export default function headerScrollWhite() {
  if ((window.pageYOffset > 10) && (window.innerWidth > 991)) {
    document.querySelector('.header').classList.add('white', 'scroll');
  }
  else {
    document.querySelector('.header').classList.remove('white', 'scroll');
  }
}



// WEBPACK FOOTER //
// ./scripts/partials/headerWhite.js